import { render, staticRenderFns } from "./MergeFiles.vue?vue&type=template&id=396abfce&scoped=true&"
import script from "./MergeFiles.vue?vue&type=script&lang=js&"
export * from "./MergeFiles.vue?vue&type=script&lang=js&"
import style0 from "./MergeFiles.vue?vue&type=style&index=0&id=396abfce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396abfce",
  null
  
)

export default component.exports